import { createRoot } from 'react-dom/client'
import { Suspense } from 'react'
import { ThemeProvider } from 'next-themes'
import App from './App.tsx'
import './index.css'
// import './lib/sentry' // Disabled temporarily
import './lib/i18n'

// Unregister any existing service workers
if ('serviceWorker' in navigator) {
	navigator.serviceWorker.getRegistrations().then((registrations) => {
		registrations.forEach((registration) => {
			registration.unregister()
		})
	})
}

createRoot(document.getElementById('root')!).render(
	<Suspense
		fallback={
			<div className="flex h-screen w-full items-center justify-center bg-background">
				<div className="flex flex-col items-center gap-4">
					<div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
					<p className="text-sm text-muted-foreground">Loading...</p>
				</div>
			</div>
		}
	>
		<ThemeProvider attribute="class" defaultTheme="light">
			<App />
		</ThemeProvider>
	</Suspense>
)
